import { AddIcon } from '../../../../../../../../assets/icons/controls/controls';

function EmptyState({ onAdd, text, buttonText, canEditStructure }) {
    return (
        <div className='edit-main-page__empty'>
            {text}
            {canEditStructure ?
                <button
                    className='edit-main-page__empty-add'
                    type='button'
                    onClick={onAdd}
                >
                    <AddIcon
                        mainClassName={'edit-main-page__empty-add-icon'}
                        fillClassName={'edit-main-page__empty-add-icon-fill'}
                    />
                    {buttonText}
                </button>
                : null}
        </div>
    );
}

export default EmptyState;
